module.exports = __webpack_public_path__ + "static/letterboxbib1-f65a0e1629e447973fb3066d2aa386c0.png";